import { useEffect, useState } from 'react';

import { MOBILE_BREAKPOINT_WIDTH } from '../constants/device';
import { WindowSizeContextProps } from 'contexts/WindowSizeContext.types';

export const calcWindowSize = (): WindowSizeContextProps => {
    const width = window.visualViewport?.width || window.innerWidth;
    const height = window.visualViewport?.height || window.innerHeight;

    return {
        width,
        height,
        isMobile: width <= MOBILE_BREAKPOINT_WIDTH,
        visibleHeight: height,
    };
};

const useWindowSize = (): WindowSizeContextProps => {
    const [windowSize, setWindowSize] = useState<WindowSizeContextProps>(calcWindowSize());

    useEffect(() => {
        // Debounce to mitigate perf issues from frequent resizes
        let timeoutId: NodeJS.Timeout;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setWindowSize(calcWindowSize());
            }, 100);
        };

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleResize);
            window.visualViewport.addEventListener('scroll', handleResize);
        } else {
            window.addEventListener('resize', handleResize);
        }

        handleResize();

        return () => {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', handleResize);
                window.visualViewport.removeEventListener('scroll', handleResize);
            } else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);

    return windowSize;
};

export default useWindowSize;
